import  React from 'react';

import PersonIdentities from './PersonIdentities'
import PersonLink from './PersonLink'

import styles from './PersonStripView.sass';

export default ({person}) => (
    <div className={styles.root}>
        <h4>
            <PersonLink person={person}>
                <span>{person.name.given}</span> {person.name.family}
            </PersonLink>
            <PersonIdentities Element='span' bare person={person} />
        </h4>
        <img src={person.photo.normal || '/img/people/__placeholder.png'} />
        <div className="g-type-minor" dangerouslySetInnerHTML={{__html: person.bio.summary || person.bio.full}} />
    </div>
);


// WEBPACK FOOTER //
// ./src/modules/People/elements/PersonStripView.js